<template>
    <!-- 头部 -->
    <div class="mhead">
      <div class="mheada clear">
        <a href="/"><img src="~@/assets/img/m/logo.png" class="mlogo left"/></a>
        <!-- <img src="~@/assets/img/m/menu.png" class="menu right" @click="changeStatus()"/> -->
        <nav :class="visiable?'mmenua right mmenu':'mmenu right'" @click="changeStatus()">
            <span></span>
        </nav>
        <a href="/" class="right" style="display:block;margin-top:0.825rem;margin-right:1rem;line-height:1.25rem;font-size:0.75rem;color: #1a1a1a;" v-if="menuId!=1">返回首页</a>
      </div>
      <div :class="visiable?'mheada_one mheada_one1':'mheada_one'">
            <ul class="mheadb">
              <li :class="menuId==1?'active':''"><a href="/">首页</a></li>
              <li :class="menuId==2?'active':''"><a href="/profile">关于我们</a></li>
              <li :class="menuId==3?'active':''"><a href="/mergence">资产布局</a></li>
              <li :class="menuId==4?'active':''"><a href="/invest">投资项目</a></li>
              <li :class="menuId==5?'active':''"><a href="/newslist?type=1">新闻中心</a></li>
              <li :class="menuId==6?'active':''"><a href="/talent">加入我们</a></li>
          </ul>
      </div>
    </div>
</template>
<script>
import { WOW } from 'wowjs';
export default {
    data () {
        return {
          menuId:1,
          visiable:false
        }
    },
    created () {

    },
    mounted () {
        
    },
    methods: {
      changeStatus(){
        this.visiable=!this.visiable;
        var wow = new WOW({
          boxClass: 'wow', /// 动画元件css类（默认为wow）
          animateClass: 'animate__animated', // 动画css类（默认为animated）
          offset: 0, // 到元素距离触发动画（当默认为0）
          mobile: true, // 在移动设备上触发动画（默认为true）
          live: true // 对异步加载的内容进行操作（默认为true）
        })
        wow.init()
      }
    }
}
</script>


// WEBPACK FOOTER //
// src/views/mobile/header.vue